"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const formik_1 = require("formik");
const Table_1 = __importDefault(require("@mui/material/Table"));
const formik_2 = require("formik");
const TableBody_1 = __importDefault(require("@mui/material/TableBody"));
const uuid_1 = require("uuid");
const DynamicTableRow_1 = __importDefault(require("@/components/DynamicTable/DynamicTableRow"));
const DyanmicTableHead_1 = __importDefault(require("@/components/DynamicTable/DyanmicTableHead"));
const SimpleCell_1 = __importDefault(require("@/components/DynamicTable/Cells/SimpleCell"));
const AutocompleteField_1 = __importDefault(require("@/components/AutocompleteField"));
const DeletableCell_1 = __importDefault(require("@/components/DynamicTable/Cells/DeletableCell"));
const Button_1 = __importDefault(require("@/components/Button"));
const TableLoader_1 = __importDefault(require("@/components/TableLoader"));
const EvaluatorGroupTableTitle_1 = __importDefault(require("./components/EvaluatorGroupTableTitle"));
const constants_1 = require("@/pages/commons/constants");
const styles_1 = require("./styles");
function EvaluatorGroupTableView({ evaluatorGroupName, rows, users, onDelete, isLoading, }) {
    const formik = (0, formik_2.useFormikContext)();
    const tableRef = react_1.default.useRef(null);
    react_1.default.useEffect(() => {
        if (formik?.initialValues["evaluatorsGroup"].length !==
            rows["evaluatorsGroup"].length &&
            tableRef?.current) {
            const previousTopHeight = tableRef?.current?.scrollHeight - tableRef?.current?.scrollTop;
            tableRef.current.scrollTop =
                tableRef?.current?.scrollHeight + previousTopHeight;
        }
    }, [rows, formik.initialValues, tableRef]);
    const onChange = react_1.default.useCallback((arrayHelpers, index) => (event, value, reason) => {
        if (reason === "clear") {
            arrayHelpers.form.setFieldValue(`evaluatorsGroup[${index}]`, {
                username: "",
                email: "",
                operation: "add",
                roles: [],
                id: "",
                department: "",
            });
            return;
        }
        const newValue = {
            username: value?.username,
            id: value?.id,
            email: value?.email,
            department: value?.department,
            roles: [...value?.roles],
            operation: "add",
        };
        arrayHelpers.form.setFieldValue(`evaluatorsGroup[${index}]`, {
            ...newValue,
        });
        setTimeout(formik.submitForm, 0);
    }, []);
    const getOptionLabel = (option) => {
        if (typeof option === "string") {
            return option;
        }
        return option?.username;
    };
    const onDeleteEvaluator = (evaluator) => () => {
        onDelete(evaluator);
    };
    const isOptionEqualToValue = (option, value) => {
        if (typeof value === "string") {
            return value === option?.username || value === "Select Evalutor";
        }
        if (value?.username) {
            return option?.username === value?.username;
        }
        return true;
    };
    const onAddEvaluator = (arrayHelpers) => () => {
        arrayHelpers.push({
            username: "",
            email: "",
            operation: "add",
            roles: [],
            id: "",
            department: "",
        });
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        isLoading && (react_1.default.createElement(TableLoader_1.default, { tableLoaderStyle: { height: "250px", marginBottom: "120px" } })),
        !isLoading && (react_1.default.createElement(styles_1.StyledForm, { key: (0, uuid_1.v4)() },
            react_1.default.createElement(EvaluatorGroupTableTitle_1.default, { sx: styles_1.titleStyles, key: (0, uuid_1.v4)(), evaluatorGroupName: evaluatorGroupName }),
            " ",
            react_1.default.createElement(formik_1.FieldArray, { name: "evaluatorsGroup", validateOnChange: true, key: (0, uuid_1.v4)() }, (arrayHelpers) => {
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(styles_1.ScrollableTableContainer, { key: (0, uuid_1.v4)(), ref: tableRef },
                        react_1.default.createElement(Table_1.default, { stickyHeader: true, key: (0, uuid_1.v4)(), sx: { height: "fit-content" } },
                            react_1.default.createElement(DyanmicTableHead_1.default, { key: (0, uuid_1.v4)(), tableHeadCells: constants_1.TABLE_HEAD_CELLS }),
                            react_1.default.createElement(TableBody_1.default, { key: (0, uuid_1.v4)() }, rows["evaluatorsGroup"]?.map((row, index) => {
                                const errorMessage = formik?.errors?.evaluatorsGroup
                                    ? formik?.errors?.evaluatorsGroup[index]
                                    : { username: "" };
                                return (react_1.default.createElement(DynamicTableRow_1.default, { key: (0, uuid_1.v4)() },
                                    react_1.default.createElement(SimpleCell_1.default, { variant: "body", key: (0, uuid_1.v4)() },
                                        react_1.default.createElement(AutocompleteField_1.default, { value: row?.username, readOnly: row?.operation !== "add", getOptionLabel: getOptionLabel, isOptionEqualToValue: isOptionEqualToValue, key: (0, uuid_1.v4)(), helperText: errorMessage
                                                ?.username, error: errorMessage
                                                ?.username !== "", placeholder: "Select Evaluator", onChange: onChange(arrayHelpers, index), id: `evaluatorsGroup[${index}].username`, name: `evaluatorsGroup[${index}].username`, options: users })),
                                    react_1.default.createElement(SimpleCell_1.default, { variant: "body", key: (0, uuid_1.v4)() }, constants_1.DEPARTMENTS.get(row?.department)),
                                    react_1.default.createElement(SimpleCell_1.default, { variant: "body", key: (0, uuid_1.v4)() }, row?.email),
                                    react_1.default.createElement(SimpleCell_1.default, { variant: "body", key: (0, uuid_1.v4)() }, row?.roles
                                        ?.map((role) => {
                                        return constants_1.ROLES.get(role);
                                    })
                                        .join(", ")),
                                    react_1.default.createElement(DeletableCell_1.default, { key: (0, uuid_1.v4)(), onDelete: onDeleteEvaluator(row), align: "right", disabled: row?.username === "" })));
                            })))),
                    react_1.default.createElement(styles_1.AddEvaluatorWrapper, { key: (0, uuid_1.v4)() },
                        react_1.default.createElement(Button_1.default, { key: (0, uuid_1.v4)(), label: "Add Evaluator", variant: "outlined", color: "secondary", disabled: arrayHelpers.form.values["evaluatorsGroup"][arrayHelpers.form.values["evaluatorsGroup"].length - 1]?.username === "", onClick: onAddEvaluator(arrayHelpers) }))));
            })))));
}
exports.default = EvaluatorGroupTableView;
